import { apolloClient } from "../../vue-apollo";
import { MODULES } from "../../graphql/subscriptions";
import { INSERT_VISTO_GENERAL } from "../../graphql/mutations";
import { exMut } from "../../graphql/gql";

export default {
  namespaced: true,
  state: {
    moduloVisto: {},
  },
  mutations: {
    SET_MODULO_VISTO(state, payload) {
      state.moduloVisto = payload.reduce( (acc, curr) => ({ 
        ...acc, [curr.modulo.moduloGeneral.id_modulo]: curr 
      }), {});
    },
  },
  actions: {
    subscribeToModuloVisto({ commit }, variables) {
      apolloClient
      .subscribe({
        query: MODULES.CHECK_MODULO_VISTO,
        variables,
      })
      .subscribe({
        
        next({ data }) {
          commit("SET_MODULO_VISTO", data.CheckModuloVisto);
        },
        error(err) {
            console.error("Error en la suscripción:", err);
          },
        });
    },
    async insertVisto(_, data_) {
      console.log("insert visto", data_);
      
      exMut(INSERT_VISTO_GENERAL, data_).then((res) => {
        console.log("visto" , res);
      }).catch((err) => console.log("no visto",err));
    },
  },
};
